import { DynamicAttributeEditor } from "@/modules/dynamic-attributes/widgets/dynamic-attribute-editor";
import { DynamicAttributeEntity } from "gql/graphql";
import { useModelId } from "../../model/model-id/use-model-id";

export function DynamicAttributesForm() {
  const { modelId } = useModelId();

  return (
    <DynamicAttributeEditor
      config={{
        entity: DynamicAttributeEntity.CommonDynamicApprovingRequest,
        category: modelId,
      }}
    />
  );
}
